import { NavLink, Outlet, useMatch } from "react-router-dom";
import MetaData from "../../../components/MetaData";

const CategoryMetaData = () => {
  // Detect add page
  const isAddPage = useMatch(
    "/MetadataManagement/CategoryMetaData/AddMetaCategory"
  );

  // Detect edit page (dynamic id)
  const isEditPage = useMatch(
    "/MetadataManagement/CategoryMetaData/EditCatMetaData/:id"
  );

  // Show list only on main page
  const showList = !isAddPage && !isEditPage;

  return (
    <>
      {/* ✅ Add Button – only on list page */}
      {showList && (
        <div className="d-flex justify-content-end mb-3">
          <NavLink to="AddMetaCategory" className="Button">
            <i className="fa fa-plus" /> Add Meta Data CAT
          </NavLink>
        </div>
      )}

      {/* ✅ Table – only on list page */}
      {showList && <MetaData type="CATEGORY" />}

      {/* ✅ Add / Edit Forms render here */}
      <Outlet />
    </>
  );
};

export default CategoryMetaData;
